// extracted by mini-css-extract-plugin
export default {"tabBar":"Tab_tabBar__H9uaN","listWrapper":"Tab_listWrapper__+so0H","list":"Tab_list__YMomd","item":"Tab_item__HDwgW","active":"Tab_active__NC931","line":"Tab_line__uvJwv"};